var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multi-select-box',{attrs:{"is-show-selected-len":true,"item-list":_vm.tags,"parent-data-key":"selectedTags","parent-data":_vm.selectedTags,"item-text-key":"text","item-value-key":"id","size":_vm.size,"isImmediate":_vm.isImmediate,"placeholder":_vm.placeholder,"noDataText":_vm.noDataText,"noDataAll":true},on:{"selectedChange":function (key, value) { this$1[key] = value },"subEvent":_vm.findTag}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a70ea7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/ticket/component/ticketlist/layout/tag_search_auto_complete.vue
// module id = null
// module chunks = 